  import { defineComponent, type PropType } from "vue";
  import AdresseAdresse1 from '@/extend/controls/adresse/AdresseAdresse1';
  import AdresseAdresse2 from '@/extend/controls/adresse/AdresseAdresse2';
  import AdresseCodePostal from '@/extend/controls/adresse/AdresseCodePostal';
  import AdresseVille from '@/extend/controls/adresse/AdresseVille';
  import PaysSelect from '@/extend/controls/pays/PaysSelect';
  import Adresse from '@/extend/classes/Adresse';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeAdresse } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      AdresseAdresse1,
      AdresseAdresse2,
      AdresseCodePostal,
      AdresseVille,
      PaysSelect,
    },

    props: {
      adresse: {
        type: Object as PropType<Adresse>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetPaysSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        adresse1Status: new FieldStatus(false, false, 0),
        strAdresse1: '',
        adresse2Status: new FieldStatus(false, false, 0),
        strAdresse2: '',
        codePostalStatus: new FieldStatus(false, false, 0),
        strCodePostal: '',
        villeStatus: new FieldStatus(false, false, 0),
        strVille: '',
    togglePaysId: false,
        paysIdStatus: new FieldStatus(false, false, 0),
        strPaysId: '',
        refAdresse: new Adresse,
        cloneAdresse: new Adresse,
      adresseSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.ADRESSE,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editAdresse.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editAdresse: {
        get(): Adresse {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.adresse != undefined) {
              if (this.adresse.id == 0) {
                Alerts.debug('CrudAdresse : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneAdresse.id != this.adresse.id && !this.saving) {
                this.handleAdresseChange();
              }
            }
          }
          return this.refAdresse;
        },
        set(value: Adresse) {
          this.refAdresse = value;
        }
      },

      canCreate (): boolean {
        return this.refAdresse.id > 0;
      },

      canDelete (): boolean {
        return this.refAdresse.canDelete && this.refAdresse.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      adresse1: {
        get(): string {
          return this.editAdresse.adresse1;
        },
        set(value: string) {
          this.editAdresse.adresse1 = value;
          this.fieldUpdated('ADRESSE1', value);
        }
      },


      adresse2: {
        get(): string {
          return this.editAdresse.adresse2;
        },
        set(value: string) {
          this.editAdresse.adresse2 = value;
          this.fieldUpdated('ADRESSE2', value);
        }
      },


      codePostal: {
        get(): string {
          return this.editAdresse.codePostal;
        },
        set(value: string) {
          this.editAdresse.codePostal = value;
          this.fieldUpdated('CODE_POSTAL', value);
        }
      },


      ville: {
        get(): string {
          return this.editAdresse.ville;
        },
        set(value: string) {
          this.editAdresse.ville = value;
          this.fieldUpdated('VILLE', value);
        }
      },

    resetPaysId (): boolean {
      return this.togglePaysId
    },

      paysId: {
        get(): number {
          return this.editAdresse.paysId;
        },
        set(value: number) {
          this.editAdresse.paysId = value;
          this.fieldUpdated('PAYS_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.adresse.canUpdate && (
        (this.isDisplayed('ADRESSE1') && !this.readOnly('ADRESSE1')) ||
        (this.isDisplayed('ADRESSE2') && !this.readOnly('ADRESSE2')) ||
        (this.isDisplayed('CODE_POSTAL') && !this.readOnly('CODE_POSTAL')) ||
        (this.isDisplayed('VILLE') && !this.readOnly('VILLE')) ||
        (this.isDisplayed('PAYS_ID') && !this.readOnly('PAYS_ID')));
        return !res;
      },

      fields (): string[] {
        return ['ADRESSE1', 'ADRESSE2', 'CODE_POSTAL', 'VILLE', 'PAYS_ID'];
      },
    },

    methods: {
      handleAdresseChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.adresse);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.adresse);
          }
        } else if (!this.inDialog) {
          if (this.cloneAdresse.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.adresse);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.adresse1Status != undefined && this.adresse1Status.updated) ||
          (this.adresse2Status != undefined && this.adresse2Status.updated) ||
          (this.codePostalStatus != undefined && this.codePostalStatus.updated) ||
          (this.villeStatus != undefined && this.villeStatus.updated) ||
          (this.paysIdStatus != undefined && this.paysIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.adresse);
        }
      },

      setError (): void {
        const error = this.adresse1Status.error ||
        this.adresse2Status.error ||
        this.codePostalStatus.error ||
        this.villeStatus.error ||
        this.paysIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.adresse);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refAdresse.id < 0) {
          storeAdresse.mAdresseDeleted(this.refAdresse.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refAdresse.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveAdresse()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.adresseSaving = false;
          this.createRef(this.refAdresse);
          this.$emit('updated', this.refAdresse);
          if (this.adresse.id > 0) {
            this.$emit('saved', this.refAdresse);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refAdresse.failed) {
          this.saveLoading = false;
            this.adresseSaving = false;
            this.refAdresse.failed = false;
          }
        }
      },

      saveAdresse (): boolean {
        if (!this.refAdresse.compareAdresse(this.cloneAdresse)) {
          if (!this.adresseSaving) {
            this.adresseSaving = true;
          if (this.refAdresse.id > 0) {
            storeAdresse.updateAdresse(this.refAdresse)
              .then((data: Adresse) => {
                if (!data.failed) {
                  this.refAdresse = storeAdresse.getAdresse(data.id);
                  this.cloneAdresse = data.cloneAdresse();
                } else {
                  this.refAdresse.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.adresseSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refAdresse.id <= 0) {
              storeAdresse.createAdresse(this.refAdresse)
                .then((data: Adresse) => {
                  if (!data.failed) {
                    this.refAdresse = storeAdresse.getAdresse(data.id);
                    this.cloneAdresse = data.cloneAdresse();
                  } else {
                this.refAdresse.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.adresseSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refAdresse.id <= 0) {
          storeAdresse.mAdresseDeleted(this.refAdresse.id);
        } else {
          storeAdresse.deleteAdresse(this.refAdresse);
        }
      },

      statusAdresse1 (value: FieldStatus): void {
        this.adresse1Status = value;
        this.setUpdated();
        this.setError();
      },
      statusAdresse2 (value: FieldStatus): void {
        this.adresse2Status = value;
        this.setUpdated();
        this.setError();
      },
      statusCodePostal (value: FieldStatus): void {
        this.codePostalStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusVille (value: FieldStatus): void {
        this.villeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPaysId (value: FieldStatus): void {
        this.paysIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteAdresse(): void {
        this.$emit('deleteAdresse',  this.adresse);
      },

    addAdresse(): void {
      this.$emit('addAdresse',  this.adresse);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneAdresse != undefined) {
          this.restoring = true;
          this.refAdresse.adresse1 = this.cloneAdresse.adresse1;
          this.refAdresse.adresse2 = this.cloneAdresse.adresse2;
          this.refAdresse.codePostal = this.cloneAdresse.codePostal;
          this.refAdresse.ville = this.cloneAdresse.ville;
          this.refAdresse.paysId = this.cloneAdresse.paysId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Adresse): void {
        this.clearRef();
        this.editAdresse = value;
        this.cloneAdresse = value.cloneAdresse();
        this.adresse1Status.clear(value.id);
        this.adresse2Status.clear(value.id);
        this.codePostalStatus.clear(value.id);
        this.villeStatus.clear(value.id);
        this.paysIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE1') && this.$refs.ADRESSE1) this.$refs.ADRESSE1.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE2') && this.$refs.ADRESSE2) this.$refs.ADRESSE2.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE_POSTAL') && this.$refs.CODE_POSTAL) this.$refs.CODE_POSTAL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE') && this.$refs.VILLE) this.$refs.VILLE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_ID') && this.$refs.PAYS_ID) this.$refs.PAYS_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ADRESSE1') && this.isDisplayed('ADRESSE1') && this.$refs.ADRESSE1 && this.$refs.ADRESSE1.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ADRESSE2') && this.isDisplayed('ADRESSE2') && this.$refs.ADRESSE2 && this.$refs.ADRESSE2.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CODE_POSTAL') && this.isDisplayed('CODE_POSTAL') && this.$refs.CODE_POSTAL && this.$refs.CODE_POSTAL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'VILLE') && this.isDisplayed('VILLE') && this.$refs.VILLE && this.$refs.VILLE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PAYS_ID') && this.isDisplayed('PAYS_ID') && this.$refs.PAYS_ID && this.$refs.PAYS_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE1') && this.$refs.ADRESSE1) this.$refs.ADRESSE1.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE2') && this.$refs.ADRESSE2) this.$refs.ADRESSE2.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CODE_POSTAL') && this.$refs.CODE_POSTAL) this.$refs.CODE_POSTAL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE') && this.$refs.VILLE) this.$refs.VILLE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_ID') && this.$refs.PAYS_ID) this.$refs.PAYS_ID.save();
      },

      getValue (field: string): string {
         if (field == 'ADRESSE1') return this.adresse1.toString();
        else  if (field == 'ADRESSE2') return this.adresse2.toString();
        else  if (field == 'CODE_POSTAL') return this.codePostal.toString();
        else  if (field == 'VILLE') return this.ville.toString();
        else  if (field == 'PAYS_ID') return this.paysId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
